import type { MaybeRef } from "vue"
import type { IEventThemeJsonRequestV1 } from "@/types"
import { useMutation } from "@tanstack/vue-query"
import { toValue } from "vue"
import { v1 } from "@/axios"

export async function updateEventTheme(eventVaultId: number, theme: IEventThemeJsonRequestV1) {
  await v1.patch(`/events/${eventVaultId}/theme`, theme)
}

export const UPDATE_EVENT_THEME = "updateEventTheme"

export function useUpdateEventTheme(eventVaultId?: MaybeRef<number | undefined>) {
  return useMutation({
    mutationKey: [UPDATE_EVENT_THEME, eventVaultId],
    mutationFn: (theme: IEventThemeJsonRequestV1) => updateEventTheme(toValue(eventVaultId)!, theme),
  })
}
